import { Col, Form, FormProps, Input, InputNumber, Row } from "antd";
import Nota from "../../../../../Models/Financeiro/Titulo/Nota";
import ServicoSelect from "../../Faturamento/Servico/ServicoSelect";
import dayjs from 'dayjs';
import NotaSituacaoSelect from "./NotaSituacao/NotaSituacaoSelect";
import { forwardRef, useEffect } from "react";
import { FormInstance } from "antd/lib/form/Form";
import { EnumNotaSituacao } from "../../../../../Models/Financeiro/Titulo/Nota/NotaSituacao";
import PessoaSelectComTipo from "../../../Pessoa/PessoaSelect";
import { BooleanProps } from "../../../../../utility-types";
import InputDate from "../../../../Base/Input/InputDate";

export interface NotaFormInstanceRef extends FormInstance<Nota> {
};

interface INotaFormBasicProps extends Omit<FormProps, "disabled"> {
    nota:Nota;
    disabled?:BooleanProps<Nota>
}

const NotaFormBasic = forwardRef<NotaFormInstanceRef, INotaFormBasicProps>(function NotaFormBasic(
    {
        nota,
        form : formParam,
        disabled,
        ...rest
    }, 
    ref
) {
    const [ newForm ] = Form.useForm<Nota>();
    const form = formParam ?? newForm;

    const codSituacao = Form.useWatch(["codSituacao"], form);
    const codTitulo = Form.useWatch(["codTitulo"], form);

    useEffect(() => {
        form.setFieldsValue({
            ...nota,
            dataCompetencia : dayjs(nota.dataCompetencia),
            codServico : nota.codServico <= 0 ? undefined : nota.codServico
        } as any);
    }, [nota]);

    return <Form
        {...rest}
        ref={ref}
        form={form}
        component={"div"}
        layout="vertical"
        autoComplete="off"
        style={{
            overflowX : "hidden",
            overflowY : "auto",
            maxHeight: 'calc(100vh - 200px)'
        }}
        initialValues={{
            ...nota,
            dataCompetencia : dayjs(nota.dataCompetencia),
            codServico : nota.codServico <= 0 ? undefined : nota.codServico
        } as Nota}
    >
        <Row gutter={8} wrap>
            <Form.Item hidden name={"codigo"} rules={[ { required : false } ]}></Form.Item>
            <Form.Item<Nota> hidden label={"Titulo"} name={"codTitulo"} rules={[ { required : false } ]}></Form.Item>
            {/* <Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
                <Form.Item<Nota> label={"Serviço"} name={"codServico"} rules={[
                    // {
                    //     required : true,
                    //     message : "Por favor, selecione Serviço"
                    // }
                ]}>
                    <ServicoSelect />
                </Form.Item>
            </Col> */}
            {/* {(codTitulo ?? 0) <= 0 && <> */}
                <Col xs={24} sm={12}>
                    <PessoaSelectComTipo<Nota>
                        names={{
                            tipo : ["prestador", "tipo"],
                            "*" : ["codPrestador"]
                        }}
                        label="Prestador"
                        rules={{
                            tipo : [{ required: true }],
                            "*" : [{ required: true, message : "Por favor, selecione um prestador" }],
                        }}
                        disabled={(disabled as BooleanProps<Nota>)?.codPrestador || (codTitulo ?? 0) > 0}
                    />
                </Col>

                <Col xs={24} sm={12}>
                    <PessoaSelectComTipo<Nota>
                        names={{
                            tipo : ["tomador", "tipo"],
                            "*" : ["codTomador"]
                        }}
                        label="Tomador"
                        // rules={{
                        //     tipo : [{ required: true }],
                        //     "*" : [{ required: true, message : "Por favor, selecione um prestador" }],
                        // }}
                        disabled={(disabled as BooleanProps<Nota>)?.codTomador || (codTitulo ?? 0) > 0}
                    />
                </Col>

                {/* <Col xs={24} sm={12}>
                    <PessoaSelectComTipo<Nota>
                        names={{
                            tipo : ["intermediario", "tipo"],
                            "*" : ["codIntermediario"]
                        }}
                        disabled={(disabled as BooleanProps<Nota>)?.codIntermediario || (codTitulo ?? 0) > 0}
                    />
                </Col> */}
            {/* </>} */}
            <Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
                <Form.Item<Nota> 
                    label="Competência" 
                    name={"dataCompetencia"}
                    rules={[ { required : true } ]}
                >
                    <InputDate disabled={(disabled as BooleanProps<Nota>)?.dataCompetencia as boolean} />
                </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
                <Form.Item<Nota> 
                    label="Valor" 
                    name={"valor"}
                    rules={[ { required : true } ]}
                >
                    <InputNumber<number>
                        style={{ width: "100%" }} 
                        min={0} 
                        precision={2}
                        controls={false} 
                        placeholder="Valor (R$)" 
                        disabled={disabled?.valor}
                    />
                </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
                <Form.Item<Nota> 
                    label="RPS" 
                    name={"numeroRps"}
                >
                    <InputNumber<number>
                        style={{ width: "100%" }} 
                        min={0} 
                        precision={0}
                        controls={true} 
                        placeholder="RPS"
                        disabled={disabled?.numeroRps ?? undefined}
                    />
                </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
                <Form.Item<Nota> 
                    label="Série RPS" 
                    name={"serieRps"}
                >
                    <InputNumber<number>
                        style={{ width: "100%" }} 
                        min={0} 
                        precision={0}
                        controls={true} 
                        placeholder="Série RPS" 
                        disabled={disabled?.serieRps ?? undefined}
                    />
                </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
                <Form.Item<Nota> 
                    label="Nota" 
                    name={"numero"}
                    rules={[ { required : codSituacao === EnumNotaSituacao.Emitida } ]}
                >
                    <InputNumber<number>
                        style={{ width: "100%" }} 
                        min={0} 
                        precision={0}
                        controls={true} 
                        placeholder="Nota"
                        disabled={disabled?.numero ?? undefined}
                    />
                </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
                <Form.Item<Nota> label={"Situação"} name={"codSituacao"} rules={[
                    {
                        required : true,
                        message : "Por favor, selecione uma situação"
                    }
                ]}>
                    <NotaSituacaoSelect 
                        disabled={disabled?.codSituacao ?? undefined}
                    />
                </Form.Item>
            </Col>
            <Col xs={24}>
                <Form.Item<Nota> 
                    label="URL" 
                    name={"url"}
                    rules={[ { required : false, max : 500,  type : "url" } ]}
                >
                    <Input
                        maxLength={500}
                        placeholder="URL" 
                        style={{ width: "100%" }}
                        allowClear={true}
                        disabled={disabled?.url ?? undefined}
                    ></Input>
                </Form.Item>
            </Col>
            <Col xs={24}>
                <Form.Item<Nota> 
                    label="Informações adicionais" 
                    name={"informacaoAdicional"}
                    rules={[ { required : false, max : 500 } ]}
                >
                    <Input.TextArea
                        maxLength={500}
                        placeholder="Informação adiIcional" 
                        style={{ width: "100%" }}
                        allowClear={true}
                        rows={2}
                        disabled={disabled?.informacaoAdicional ?? undefined}
                    ></Input.TextArea>
                </Form.Item>
            </Col>
        </Row>
    </Form>
});

export default NotaFormBasic;